import React, { useEffect, useRef, useState, Suspense } from "react";
import { useNavigate } from "react-router-dom";
import FormCreator from "../../../components/Forms/FormCreator";
import Buttons from "../../../components/ui/button/Buttons";
import MolGrid from "../../../components/Grid/MolGrid";
import { ApproveSGBPCategoryCriteriaData } from "./data/ApproveSGBPCategoryCriteriaData";
import { ApproveSGBPCategoryCriteriaConfig } from "./data/ApproveSGBPCategoryCriteriaConfig";
import { useGetAllCategoryCriteriaMappingListForApprovalMutation, useGetAllCategoryCriteriaMappingListMutation, useLazyGetAllDropdownForCRUDCategoryQuery } from "../../../app/services/Crud/crudApi";
import { setAllDropDownField } from "./Utils/setAllDropDownField";
import { encryptAESID } from "../../../utils/Encryption";
import DataLoader from "../../../components/ui/dataLoader/DataLoader";

const ApproveSGBPCategoryList = () => {
  const navigate = useNavigate();
  const molGridRef = useRef();
  const SGBPCategoryCriteriaRef = useRef();
  const [formData, setFormData] = useState(ApproveSGBPCategoryCriteriaData);
  const [paginationRequest, setPaginationRequest] = useState({
    pageNo: 1,
    pageSize: 20,
    SearchByCode: null,
    CategoryId: null,
    SubCategoryId: null,
    TypeId: null,
    StatusId: null,
    ChannelId: null,
  });
  const [dataSource, setDataSource] = useState([])
  const [getAllCategoryCriteriaMappingList, { data: allCategoryCriteriaMappingListData, isLoading: allCategoryCriteriaMappingListLoading }] = useGetAllCategoryCriteriaMappingListForApprovalMutation();
  const [getDropdowns, { data: dropdownData, isLoading: dropdownLoading },] = useLazyGetAllDropdownForCRUDCategoryQuery();

  useEffect(() => {
    if (!allCategoryCriteriaMappingListLoading && allCategoryCriteriaMappingListData) {
      let categoryRecord = allCategoryCriteriaMappingListData.itemList.map((item) => {
        return {
          ...item,
          subCategoryL2Name: item?.subCategoryL2Name == null ? "-" : item.subCategoryL2Name,
          typeL3Name: item?.typeL3Name == null ? "-" : item.typeL3Name,
        }
      })
      setPaginationRequest((prev) => ({ ...prev, totalCount: allCategoryCriteriaMappingListData?.totalCount, }));
      setDataSource(categoryRecord)
    }
  }, [allCategoryCriteriaMappingListLoading, allCategoryCriteriaMappingListData]);

  useEffect(() => {
    getDropdowns();
    getAllCategoryCriteriaMappingList(paginationRequest);
  }, [])

  useEffect(() => {
    if (!dropdownLoading && dropdownData) {
      setAllDropDownField(dropdownData);
    }
  }, [dropdownLoading, dropdownData]);

  const handlePageChange = ({ pageNumber, pageSize }) => {
    const updatedPaginationRequest = { ...paginationRequest, pageNo: pageNumber, pageSize: pageSize };
    setPaginationRequest(updatedPaginationRequest);
    getAllCategoryCriteriaMappingList(updatedPaginationRequest);
  };

  const handleSearch = () => {
    if (!SGBPCategoryCriteriaRef.current) {
      return
    }
    const formData = SGBPCategoryCriteriaRef?.current?.getFormData();    
    const updatedPaginationRequest = {
      pageNo: 1,
      pageSize: 20,
      SearchByCode: formData?.searchByCriteriaName?.label || null,
      ChannelId: formData?.channel?.value || formData?.channel,
      StatusId: formData?.statusId?.value || formData?.statusId,
      CategoryId: formData?.categoryId?.value || formData?.categoryId,
      SubCategoryId: formData?.subCategoryId?.value || formData?.subCategoryId,
      TypeId: formData?.type?.value || formData?.type,
    };
    setPaginationRequest(updatedPaginationRequest)
    getAllCategoryCriteriaMappingList(updatedPaginationRequest);
  }

  const handleClearClick = () => {
    const updatedFormData = { ...ApproveSGBPCategoryCriteriaData };
    updatedFormData.initialState = {
      searchByCriteriaName: null,
      channel: null,
      statusId: null,
      categoryId: null,
      subCategoryId: null,
      type: null,
    };
    setPaginationRequest({
      pageNo: 1,
      pageSize: 20,
      SearchByCode: null,
      CategoryId: null,
      SubCategoryId: null,
      TypeId: null,
      StatusId: null,
      ChannelId: null,
    })

    const request = {
      pageNo: 1,
      pageSize: 20,
      SearchByCode: null,
      ChannelId: null,
      StatusId: null,
      CategoryId: null,
      SubCategoryId: null,
      TypeId: null,
    };
    setPaginationRequest((prev) => ({ ...prev, ...request }));
    getAllCategoryCriteriaMappingList(request);
    setFormData(updatedFormData);
  };

  const handleAdd = () => {
    navigate('/AddSGBPCategory')
  }

  const handleViewClick = (data) => {
    navigate(`/approveCategory/${encryptAESID(data?.sgbpCategoryCriteriaCertificateMappingId)}`);
  }

  const actionHandler = {
    VIEW: handleViewClick,
  };

  return (
    <Suspense fallback={<DataLoader />}>
      <div className="crud-requirement-list">
        <div className="corporate-member-list">
          <div className="sgbp-category">
            <div className="row status-input pr-0">
              {dropdownData?.length > 0 && <FormCreator ref={SGBPCategoryCriteriaRef} {...formData} />}
              <div className="col-4 d-flex align-items-end mt-4 gap-3">
                <Buttons
                  buttonText="Search"
                  buttonTypeClassName="search-btn "
                  onClick={handleSearch}
                />
                <Buttons
                  buttonText="Clear"
                  buttonTypeClassName="btn btn-secondary"
                  onClick={handleClearClick}
                />
              </div>
            </div>
            <div className="sgbp-category-filter">
              {/* <Buttons
              buttonText="+ Add"
              buttonTypeClassName="add-btn"
            // onClick={handleAddRow}
            /> */}
            </div>
          </div>

          <div className="member-list">

            {allCategoryCriteriaMappingListData && (
              <MolGrid
                ref={molGridRef}
                configuration={ApproveSGBPCategoryCriteriaConfig}
                dataSource={dataSource}
                allowPagination={true}
                pagination={paginationRequest}
                onPageChange={handlePageChange}
                onActionChange={actionHandler}
              />)}
          </div>
        </div>
      </div>
    </Suspense>
  );
};

export default ApproveSGBPCategoryList;
